import { useState, useEffect } from 'react';

// Takes in a callback function, a delay (in milliseconds, defaults to 1000), and dependencies to run trigger effect
// Returns nothing
export default function useDebounce(cb, delay = 1000, dependencies) {
  // Track state for triggering callback after set delay
  const [triggerCallback, setTriggerCallback] = useState(false);

  useEffect(() => {
    if (triggerCallback) {
      cb();
      setTriggerCallback(false);
    }
  }, [cb, triggerCallback]);

  useEffect(
    () => {
      // Handler for setting delay
      const handler = setTimeout(() => {
        setTriggerCallback(true);
      }, delay);

      // Clear handler when clearing effect
      return () => {
        clearTimeout(handler);
      };
    },
    [cb, delay, dependencies] // Only re-call effect if callback, delay, or dependencies change
  );
}
